import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { GoogleAnalytics } from './GoogleAnalytics';
import { useSettings } from '@/contexts/SettingsContext';

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { settings } = useSettings();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Include Google Analytics if configured */}
      {settings.googleAnalyticsId && (
        <GoogleAnalytics measurementId={settings.googleAnalyticsId} />
      )}
      
      <header>
        <Navbar />
      </header>
      <main className="flex-grow pt-16" data-testid="outlet-content">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
}